module.exports = __webpack_public_path__ + "static/media/right-arrow-page.bea8bc3a.svg";